export default __webpack_public_path__ + "static/media/ao-sugar.887173fd.svg";